import { companyPortalLoginUrlForUser } from "./companyUrl";
import { isAdminDashboardRole } from "./roles";

export type StoredAuthUser = {
  role?: string;
  subdomain?: string;
  email?: string;
};

export function readStoredUserData(): StoredAuthUser {
  try {
    return JSON.parse(localStorage.getItem("userData") || "{}") as StoredAuthUser;
  } catch {
    return {};
  }
}

export function clearAdminAuthStorage() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userData");
  localStorage.removeItem("tenantList");
  sessionStorage.clear();
}

/**
 * If a non-admin session is present, clear it and return the company portal URL.
 * Returns null when there is no token or the role is allowed / unknown.
 */
export function rejectNonAdminAdminSession(): string | null {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  const stored = readStoredUserData();
  if (stored.role && !isAdminDashboardRole(stored.role)) {
    const companyPortalUrl = companyPortalLoginUrlForUser(stored);
    clearAdminAuthStorage();
    return companyPortalUrl;
  }

  return null;
}
